<template>
    <div>
        
        <div class="stepsbox">
            <el-row>
                <el-col :span="18">
                    <el-steps direction="vertical" :active="2" finish-status="success">
                        <el-step title="新警入职" description="2012年06月20日"></el-step>
                        <el-step title="三级警司" description="2013年08月12日"></el-step>
                        <el-step title="二级警司" description="2015年09月23日"></el-step>
                    </el-steps>
                </el-col>
                <el-col :span="6">
                    <div class="stepTime">
                        <div>用时：-</div>
                        <div>用时：598 天</div>
                        <div>用时：349 天</div>
                    </div>
                </el-col>
            </el-row>
        </div>
    </div>
</template>
<script>
export default {
    
}
</script>
<style scoped>
.stepsbox{
    /* height: 400px; */
    padding: 50px 50px;
}
/deep/  .el-step__main{
    height: 100px;
}
.stepTime>div{
    height: 100px;
    color: #03b615;
}
.stepTime>:last-child{
    height: 100px;
    color: #f71000;
}
</style>